<div class="trigger-wrapper" (click)="toggleShowModal()">
  <ng-content></ng-content>
</div>

<dx-popup
  [width]="980"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'MY-TRAININGS.TRAINING-INVITE.SELECT-ATTENDEES' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="showModal"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'">
    <app-attendees-list 
      [selectedOrganisationUnitIds]="selectedOrganisationUnitIds"
      [selectedTrainingGroupIds]="selectedTrainingGroupIds"
      [(selectedPersons)]="selectedPersons"
    ></app-attendees-list>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      stylingMode: 'outlined',
      text: 'COMMON.CLOSE' | translate,
      onClick: toggle
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      text: 'MY-TRAININGS.TRAINING-INVITE.APPLY' | translate,
      onClick: onSubmitClick
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
